import React from 'react';
import Services from '../../../api/service'
import { Link } from "react-router-dom";
import folded_hands from '../../../images/folded_hands.png'
import support_agent from '../../../images/support_agent.png'
import real_estate_agent from '../../../images/real_estate_agent.png'
import fact_check from '../../../images/fact_check.png'
import { Button } from 'reactstrap'




const ConsultingService = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <>
        <section className="business_consulting_service_section section_space pt-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="heading_block text-center">

                        <span className="sub_heading">Why Us</span>
                        <br/>
                        <br/>
                        <h2 className="heading_text mb-0">
                            Why Choose Us
                        </h2>
                        </div>
                    </div>
                </div>

                <div className="business_consulting_services row">

                    <div className='mb-10'>
                        <div className='why_list_image_out'>
                            <img src={folded_hands} alt="icon"/>
                        </div>
                        <div className='col-lg-12 col-md-12 why_list'>
                            <div className='why_list_image'>
                                
                            </div>
                            <div className='why_list_text'>
                                <h2>Commitment to Quality</h2>
                                <p>We deliver SEO strategies rooted in accuracy, compliance, and measurable outcomes. Every page we create is optimized for both search engines and AI answers, ensuring long-term results.</p>
                            </div>
                        </div>
                    </div>

                    <div className='mb-10'>
                        <div className='why_list_image_out' style={{backgroundColor: '#C7E9F9'}}>
                            <img src={support_agent} alt="icon"/>
                        </div>
                        <div className='col-lg-12 col-md-12 why_list' style={{backgroundColor: '#ECF9FF'}}>
                            <div className='why_list_image'>
                                
                            </div>
                            <div className='why_list_text'>
                                <h2>Superior Customer Service</h2>
                                <p>Our team acts as your SEO partner, not just a vendor. We provide proactive communication, dedicated support, and transparent reporting at every stage.</p>
                            </div>
                        </div>
                    </div>

                    <div className='mb-10'>
                        <div className='why_list_image_out' style={{backgroundColor: '#FFF8C5'}}>
                            <img src={real_estate_agent} alt="icon"/>
                        </div>
                        <div className='col-lg-12 col-md-12 why_list' style={{backgroundColor: '#FFFCE7'}}>
                            <div className='why_list_image'>
                                
                            </div>
                            <div className='why_list_text'>
                                <h2>Proven AI-Driven Results</h2>
                                <p>From AEO/GEO optimizations to programmatic SEO, we’ve helped B2B and manufacturing companies capture high-intent demand, increase RFQs, and scale pipeline growth.</p>
                            </div>
                        </div>
                    </div>

                    <div className='mb-10'>
                        <div className='why_list_image_out' style={{backgroundColor: '#FFCFDF'}}>
                            <img src={fact_check} alt="icon"/>
                        </div>
                        <div className='col-lg-12 col-md-12 why_list' style={{backgroundColor: '#FFF3F7'}}>
                            <div className='why_list_image'>
                                
                            </div>
                            <div className='why_list_text'>
                                <h2>Data & Revenue Attribution</h2>
                                <p>We go beyond traffic metrics. Every campaign is tied to your CRM; tracking brand mentions by AI, Quotation requests, and revenue, so you know exactly how SEO fuels your business growth.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12 text-center">
                        <Button className='read_more'>Contact Now</Button>
                    </div>
                </div>

                

            </div>
        </section>
        
        </>
    );
}

export default ConsultingService;